'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import Image from 'next/image';
export interface LogoProps {
  alt: string;
  scale?: number;
}
const width = 426;
const height = 92;
export function Logo(t0) {
  const $ = _c(4);
  const {
    alt,
    scale: t1
  } = t0;
  const scale = t1 === undefined ? 0.5 : t1;
  const t2 = width * scale;
  const t3 = height * scale;
  let t4;
  if ($[0] !== alt || $[1] !== t2 || $[2] !== t3) {
    t4 = <Image src="/images/conz.png" width={t2} height={t3} alt={alt} />;
    $[0] = alt;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}